import Behaviour from "../../../lib/ui/Behaviour";
import { SolvingMethods } from "../../model/SolvingMethods";
import { observe } from "../../../lib/reactive";
import TransportLayer from "../map/TransportLayer";
var ClueAssumptions = SolvingMethods.ClueAssumptions;
export default class MethodSubEditor extends Behaviour {
    constructor(parent) {
        super();
        this.parent = parent;
        this.assumptions = observe(ClueAssumptions.init());
    }
    begin() {
        this.layer.add(new TransportLayer(true));
    }
    setAssumptions(assumptions) {
        this.assumptions.set(assumptions);
        return this;
    }
}
